const French = {
  // MENU ITEMS
  routes: 'Itinéraires',
  performance: 'Performance',
  ships: 'Navires',
  fleet: 'Flotte',
  whatIsNew: 'Quoi de neuf',
  aboutCovadem: 'À propos de CoVadem',
  selectLanguage: 'Langue',
  disclaimer: 'Clause de non-responsabilité',
  signOut: 'Se déconnecter',
  accountSettings: 'Compte',
  covadem: 'CoVadem',

  // ROUTES
  today: "Aujourd'hui",
  stationName: 'Nom du lieu',
  waterLevel: "Niveau d'eau",
  ruleOfThumb: 'Règle générale',
  lowestLoadingDepth: 'Profondeur de déchargement la plus basse',
  lowestRuleOfThumbLoadingDepth:
    'Règle empirique la plus basse concernant la profondeur de déchargement',
  latestUpdate: 'dernière mise à jour',
  moreInformation: "Plus d'informations",
  lowestWaterDepth: "Profondeur d'eau maximale disponible",
  currentlyNotShowingDueToFiltering:
    ' non visible en raison des paramètres de filtre',
  from: 'Par',
  to: 'À',
  passADate: 'Veuillez préciser une date',
  showMap: 'Afficher la carte',
  bridges: 'Pont',
  pegels: 'Échelle de niveau',
  lowestBridgeClearance: 'Hauteur de passage la plus basse',
  type: 'Taper',
  KM: 'KM',
  name: 'Nom',
  bridgeClearance: 'Hauteur',
  tendency: 'Tendance',
  routeStart: 'Point de départ',
  routeEnd: 'Point de terminaison',
  loadingDepth: 'Profondeur de déchargement',
  loadingDepthRuleOfThumb: 'Profondeur de décharge - Règle empirique',
  squatTrim: 'squat/taille',
  extraSafetyMargin: 'Marge de sécurité',
  showAll: 'Afficher tout',
  noTableData: "Il n'y a pas de données de table",
  location: 'emplacement',
  notAvailable: 'Pas disponible',
  sections: 'Sections',
  showSelections: 'Afficher la sélection',
  both: 'Les deux',
  searchNotFound: 'Aucun résultat trouvé',
  locationSearchPlaceholder: 'Localisation de recherche',
  distance: 'distance',
  via: 'via',
  noRouteAvailable: 'Aucun itinéraire disponible',
  selectRoute: 'Sélectionnez un itinéraire',
  loading: 'Chargement',
  waterLevelRepresentsValueAt: "Le niveau d'eau représente la valeur à",

  // MAP
  showTable: 'Afficher la liste',
  more: '...Plus',
  draft: 'Profondeur',

  // MAP LEGEND
  shallow: 'Peu profond',
  deep: 'Profondamente',

  // PERFORMANCE
  emptySelection: 'Sélectionnez vos paramètres',
  clickReset: 'Cliquez sur le bouton "Charger/Réinitialiser"',
  performanceOverallTitle: 'informations générales',
  showMyPerformance: 'Afficher mes réalisations',
  selectAPeriod: 'Sélectionnez la période',
  selectADateAndTime: "Sélectionnez la date et l'heure",
  period: 'Période',
  minUKCThreshold: 'Limite de dégagement de la quille',
  minUKCThresholdCM: 'Limite de dégagement de la quille (CM)',
  culture: 'nl',
  /* FIXME: this is currently not used, but maybe it will be in the future with logbooks */
  // dropDownData: [
  //   { id: 'minute', name: 'Minuut' },
  //   { id: 'hour', name: 'Uur' },
  //   { id: 'day', name: 'Dag' },
  //   { id: 'month', name: 'Maand' },
  //   { id: 'year', name: 'Jaar' },
  // ],
  export: 'Exporter',
  exportStep1: 'Choisissez les unités',
  exportStep2: 'Exporter',

  // PERF OVERVIEW
  // labels
  labels: {
    fuelFlowAverage: 'Consommation moyenne de carburant',
    speedAverage: 'Vitesse moyenne',
    UKCAverage: "Moyenne du tirant d'eau",
    draftAverage: 'Profondeur moyenne',
    squatAverage: 'Squat moyen',
    cargoWeightAverage: 'Charge moyenne',
  },

  // perf. summary/overall
  distanceTotal: 'Distance parcourue',
  speedAverage: 'Vitesse moyenne',
  fuelTotal: 'Consommation totale de carburant',
  co2Total: 'Émissions totales de CO2',
  UKCAverage: "Moyenne du tirant d'eau",
  UKCMinimal: 'Plus petit dégagement de quille observé',
  cargoWeightAverage: 'Charge moyenne',

  fuelTKm: 'Consommation de carburant',
  csv: 'CSV',
  xlsx: 'XLSX (Excel)',

  co2TotalTooltip: `CoVadem calcule les émissions de CO2 sur la base du facteur d'émission de CO2 Tank-to-Wheel (TTW) 
  établi par litre de diesel fossile. (2,657 kg CO2 / litre de diesel) Ces valeurs sont disponibles en ligne sur {0}. 
  Si vous utilisez un autre type de carburant, d'autres valeurs d'émission s'appliquent.`,

  // SHIPS
  ship: 'Bateau',
  box: 'Box',
  boxType: 'Type CoVadem Box',
  boxNumber: 'CoVadem Box s/n',

  sensorWorking: 'En service',
  sensorWarning: 'Avertissement',
  sensorError: 'Erreur',
  sensorUnavailable: 'Non disponible',

  sensors: 'Capteurs',
  sensorTypeBox: 'Box',
  sensorTypeGPS: 'GPS',
  sensorTypeHDOP: 'HDOP',
  sensorTypeCargo: 'Chargement',
  sensorTypeEcho: 'Sondeur',
  sensorTypeFuel: 'Consommateur de carburant',

  shipData: 'Données du Bateau',
  shipName: 'Nom du Bateau',
  ENINumber: 'Numéro ENI',

  shipConstructionYear: 'Année de construction',
  shipLength: 'Longueur',
  shipWidth: 'Largeur',
  shipHeight: 'Hauteur navigable',
  shipWeight: "Déplacement d'eau",
  shipMaxCargoWeight: 'Poids maximal du chargement',
  shipMaxDraft: 'Profondeur maximale',

  // FLEET
  speed: 'Vitesse (km/h)',
  cargo: 'Poids du chargement (tonnes)',
  tons: 'Ton',
  fuel: 'Consommation de carburant (l)',
  ukc: 'Garde au sol sous la quille (m)',

  // ACCOUNT
  email: 'Email',
  fullName: 'Prénom et nom',
  companyName: "Nom de l'entreprise",
  signedUp: 'Inscrit',
  noMeasuringShips: 'Pas de navires de mesure',
  // ships: 'Bateau',

  // NOTIFICATIONS
  errorOccurred: "Une erreur s'est produite",
  reloadPage: 'Recharge la page',
  anotherUserLoggedIn:
    "Il semble qu'une session soit encore active sur un autre appareil.",
  tokenExpired: 'Votre code de connexion a expiré.',
  logInAgain: 'Veuillez vous reconnecter.',
  appUpdatesMessage:
    'La plateforme CoVadem a été élargie et améliorée. Cliquez sur "Plus d\'infos" pour obtenir un aperçu détaillé.',
  errorMessage: "Une erreur s'est produite.",
  offlineMessage:
    "Il n'y a pas de connexion Internet. Vérifiez votre connexion Wi-Fi ou votre réseau mobile.",
  moreInfoButton: "plus d'informations",
  retry: 'Essayez à nouveau.',
  announcementTitle: 'Défaut',
  announcementMessage: `Nous vous prions de nous excuser, les valeurs affichées dans le tableau de bord ne 
  correspondent pas à ce que vous êtes en droit d'attendre de notre part. 
  Cela est dû à un dysfonctionnement de notre système. Le problème a été résolu, mais cela peut prendre encore quelques jours 
  avant que toutes les données soient reconstituées et que les valeurs correctes s'affichent à nouveau dans le tableau de bord.`,

  daysDurationLimit: 'La portée maximale autorisée est de {0} jours.',

  // VALUES
  liter: 'Litres',
  ltr: 'Ltr',
  literAbbreviation: 'L',
  kilogram: 'Kilogramme',
  kilometer: 'Kilomètre',
  km: 'Km',
  meter: 'Meter',
  meterAbbreviation: 'M',
  kilometerPerHour: 'Km/H',
  meterPerSecond: 'M/s',
  literPerHour: 'l/u',
  gramTonKilometer: 'gr/t/km',
  literTonKilometer: 'l/t/km',

  // Export window
  expDateTimeDescription: 'Date et heure (UTC)',
  expCountTotalDescription: 'Nombre de mesures',
  expGPSPathDescription: 'GeoJSON LineString (uniquement avec CSV)',
  expDegrees: 'Degrés (0 à 360)',
  expGeoJsonPoint: 'Geojson point',
  expLatLongSingle: '1 colonne',
  expLatLongDouble: '2 colonnes',

  // OTHERS
  comingSoon: 'Prochainement',
  show: 'Afficher',
  moreOpt: 'Paramètres',
  dropDownPlaceholder: 'Sélectionnez une option',
  dropDownSearchPlaceholder: 'Type de recherche',
  loadResetData: 'Charger / réinitialiser',
  retryData: 'Encore',
  cancel: 'Annuler',

  // PAGES
  aboutCovademContent: "Pour plus d'informations, rendez-vous sur",

  // UNSPECIFIED
  map: 'Carte',
  table: 'Liste',
  navbarRoute: 'Routes',
  navbarPerformance: 'Performances',
  navbarShip: 'Bateau',
  navbarMore: 'Plus',
  languages: 'Langues',
  english: 'English',
  dutch: 'Nederlands',
  german: 'Deutsch',
  french: 'Français',
  startDateError: 'La date de début est obligatoire.',
  endDateError: 'Une date de fin est obligatoire',
  periodError: 'La période est obligatoire.',
  selectedShipError: 'Sélectionnez un bateau',
  dataNotAvailable: 'Aucune donnée disponible',
  noDataError: 'Aucune donnée disponible pour la période sélectionnée',
  indicator: 'Tendance',
  navNow: 'Maintenant',
  navDay: 'Jour',
  navMonth: 'Mois',
  navYear: 'Année',
  days: 'jours',
  routeDetailsButton: "afficher les détails de l'itinéraire",
  loadingShips: 'Les bateaux sont en cours de chargement...',
  selectShip: 'Sélectionnez votre bateau',
  changePeriod: 'Ajuster les paramètres',
  clickLogOut: 'Cliquez ici pour vous déconnecter',
  clickContinue: 'Cliquez ici pour continuer',
  backHome: "Retourner à la page d'accueil",
  errorScreen: "Message d'erreur",
  dataSharing: 'Partager des données',
  showLowestWarnings: 'Afficher les points critiques',
  waterChartTitle: "Différence de niveau d'eau",
  clearanceChartTitle: 'Différence de hauteur de passage sous le pont',
  chartError: 'Indisponible pour le moment.',
  graphNow: 'maintenant',
  graphDay: 'd',
  unavailable: 'Indisponible',
  basis: 'base',
  stuckedButton: 'Je suis bloqué, rechargez la page',
  ruleOfThumbAppliedWarningMessage:
    "Nous ne disposons malheureusement pas de valeurs suffisantes pour indiquer la position exacte du niveau d'eau le plus bas.",

  // ADVERTISEMENT
  becomeMeasuringShipTitle:
    'CoVadem offre des avantages aux navires équipés de systèmes de mesure',
  becomeMeasuringShipWarn: `Vous n'avez pas encore de navires mesurés, c'est pourquoi nous ne pouvons afficher aucune information sur cette page. 
                            Saviez-vous que vous passez ainsi à côté d'une réduction intéressante ? La réduction peut atteindre plus de 200 euros par an !`,
  becomeMeasuringShipSubTitle: "Mesurer, c'est savoir",
  becomeMeasuringShipDescription: `Mais vous ne mesurez pas uniquement pour CoVadem ou pour bénéficier d'une réduction, car mesurer, c'est savoir ! 
                                  Avec CoVadem, vous pouvez surveiller les performances (telles que la consommation, le chargement, la distance parcourue, 
                                  les émissions) au fil du temps. 
                                  Vous générez ainsi des informations importantes qui vous permettent d'améliorer continuellement vos performances. 
                                  Des informations qui vous permettent également de suivre l'effet des innovations ou des modifications apportées 
                                  au navire ou à l'exploitation ! 
                                  De plus, vous pouvez contribuer à la qualité des informations sur la profondeur de l'eau que nous générons chez CoVadem.`,
  becomeMeasuringShipContact: `MVous souhaitez en savoir plus ou vous inscrire directement en tant que navire de mesure ?
Contactez-nous pour connaître les possibilités ! Appelez le +31 88-2682300 ou laissez vos coordonnées via {0}, 
et nous vous contacterons dans les plus brefs délais.`,
};

export default French;
